module.exports = __webpack_public_path__ + "static/media/pressicon.a02c431b.svg";